export function isVisible(element, offset = 0) {
    let coord = element.getBoundingClientRect();
    const topSide = coord.y - window.innerHeight + offset < 0;
    const bottomSide = coord.y + coord.height - offset > 0;
    return topSide && bottomSide;
}
